// assets/qfb-nav.js
(() => {
  if (window.__qfbNavLoaded) return;
  window.__qfbNavLoaded = true;

  class QfbNav extends HTMLElement {
    connectedCallback() {
      if (this.__qfbInit) return;
      this.__qfbInit = true;

      this.collectionPath = this.getAttribute('data-collection-path') || '';
      this.scrollTargetId = this.getAttribute('data-scroll-target') || 'ProductGridContainer';

      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick, { passive: false });

      // Apply deferred scroll actions after navigation (product -> collection)
      this.runDeferredScroll();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    // ---------- Utilities ----------
    isCollectionPage() {
      if (!this.collectionPath) return window.location.pathname.startsWith('/collections/');
      return window.location.pathname === this.collectionPath;
    }

    samePath(url) {
      return url && url.pathname === window.location.pathname;
    }

    hasFilterParams(url) {
      if (!url) return false;
      for (const key of url.searchParams.keys()) {
        if (key.startsWith('filter.')) return true;
      }
      return false;
    }

    getStickyHeaderOffset() {
      const header =
        document.querySelector('.section-header') ||
        document.querySelector('#shopify-section-header');

      if (!header) return 0;

      const style = window.getComputedStyle(header);
      if (style.position !== 'fixed' && style.position !== 'sticky') return 0;

      return Math.ceil(header.getBoundingClientRect().height || 0);
    }

    getScrollTargetEl() {
      return document.getElementById(this.scrollTargetId);
    }

    scrollToEl(el) {
      if (!el) return;

      const offset = this.getStickyHeaderOffset();
      const y = el.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    scrollToHash(hash) {
      if (!hash) return;
      const id = hash.replace('#', '');
      if (!id) return;

      const el = document.getElementById(id);
      if (!el) return;

      this.scrollToEl(el);
    }

    // ---------- Facets helpers ----------
    getFacetsForm() {
      const host = document.querySelector('facet-filters-form');
      if (host) {
        const f = host.querySelector('form');
        if (f) return f;
      }
      return (
        document.querySelector('form.facets__form') ||
        document.querySelector('main form[action*="/collections/"]')
      );
    }

    dispatchInput(el) {
      if (!el) return;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    resetAll(form) {
      form.querySelectorAll('input[type="checkbox"]:checked').forEach((inp) => {
        inp.checked = false;
        this.dispatchInput(inp);
      });

      // Also clear range/text inputs for filter.* if they exist (optional but safe)
      form.querySelectorAll('input[name^="filter."]').forEach((inp) => {
        if (inp.type === 'text' || inp.type === 'number' || inp.type === 'range') {
          // Only clear if it currently has a value (avoid unnecessary churn)
          if (inp.value !== '') {
            inp.value = '';
            this.dispatchInput(inp);
          }
        }
      });
    }

    applyFiltersFromUrl(url) {
      const form = this.getFacetsForm();
      if (!form) return false;

      // Reset first: this emulates your "reset_before" behavior for menu navigation
      this.resetAll(form);

      // Apply all filter.* params from url
      // Works for:
      // - checkbox facets: input[name="filter...."][value="..."]
      // - range inputs: input[name="filter.v.price.gte"] etc.
      for (const [name, value] of url.searchParams.entries()) {
        if (!name.startsWith('filter.')) continue;

        // Try checkbox/radio first
        const selector = `input[name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`;
        const opt = form.querySelector(selector);

        if (opt && (opt.type === 'checkbox' || opt.type === 'radio')) {
          opt.checked = true;
          this.dispatchInput(opt);
          continue;
        }

        // Then fallback to input by name (range/text/number)
        const inputByName = form.querySelector(`input[name="${CSS.escape(name)}"]`);
        if (inputByName && (inputByName.type === 'text' || inputByName.type === 'number' || inputByName.type === 'range')) {
          inputByName.value = value;
          this.dispatchInput(inputByName);
        }
      }

      // Nudge form (some themes listen on form change)
      this.dispatchInput(form);

      return true;
    }

    // Wait for grid updates then scroll to ProductGridContainer
    scrollToGridAfterUpdate() {
      const grid = this.getScrollTargetEl();
      if (!grid) return;

      let doneTimer = null;
      const obs = new MutationObserver(() => {
        clearTimeout(doneTimer);
        doneTimer = setTimeout(() => {
          obs.disconnect();
          this.scrollToEl(grid);
        }, 120);
      });

      obs.observe(grid, { childList: true, subtree: true });

      // Safety fallback
      setTimeout(() => {
        try { obs.disconnect(); } catch (_) {}
        this.scrollToEl(grid);
      }, 4000);
    }

    // ---------- Deferred navigation handling (product -> collection) ----------
    setDeferred(kind, payload) {
      const key = 'qfb:deferred';
      const data = { kind, payload, t: Date.now() };
      sessionStorage.setItem(key, JSON.stringify(data));
    }

    runDeferredScroll() {
      const key = 'qfb:deferred';
      const raw = sessionStorage.getItem(key);
      if (!raw) return;

      let data;
      try { data = JSON.parse(raw); } catch (_) { return; }

      // Expire quickly (avoid stale actions)
      if (!data || !data.t || (Date.now() - data.t) > 15000) {
        sessionStorage.removeItem(key);
        return;
      }

      // Only execute if we are on the intended collection path (or any collection if not provided)
      if (this.collectionPath && window.location.pathname !== this.collectionPath) return;

      sessionStorage.removeItem(key);

      // Wait until DOM settled & target exists
      const tryRun = (tries = 0) => {
        const grid = this.getScrollTargetEl();
        if (!grid && tries < 30) return setTimeout(() => tryRun(tries + 1), 100);

        if (data.kind === 'grid') {
          this.scrollToEl(grid);
          return;
        }
        if (data.kind === 'hash') {
          this.scrollToHash(data.payload?.hash || '');
        }
      };

      // If filters present in URL, grid might still be updating; do a short delay
      setTimeout(() => tryRun(0), 50);
    }
        closeHeaderDrawerIfAny() {
        const drawer = this.closest('header-drawer');
        if (!drawer) return;

        // summary, який відкриває drawer
        const summary = drawer.querySelector('summary');
        if (!summary) return;

        // Якщо drawer вже закритий — нічого не робимо
        const details = summary.closest('details');
        if (!details || !details.hasAttribute('open')) return;

        // Викликаємо "рідний" метод Dawn
        if (typeof drawer.closeMenuDrawer === 'function') {
            drawer.closeMenuDrawer(null, summary);
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
        } else {
            // fallback (на випадок кастомної теми)
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
        }
        }

    // ---------- Click logic ----------
    onClick(e) {
      const a = e.target.closest('a');
      if (!a) return;
        this.closeHeaderDrawerIfAny();
      // Only handle same-origin links
      let url;
      try { url = new URL(a.getAttribute('href'), window.location.origin); }
      catch (_) { return; }

      if (url.origin !== window.location.origin) return;

      const isToCollection = url.pathname.startsWith('/collections/');
      const isTargetCollection = this.collectionPath ? (url.pathname === this.collectionPath) : isToCollection;

      const hasFilter = this.hasFilterParams(url);
      const hasHash = !!(url.hash && url.hash.length > 1);

      // Case A: link has FILTER params (collection filtering)
      if (hasFilter && isTargetCollection) {
        // If we are already on the collection page -> apply via facets (no reload)
        if (this.isCollectionPage() && this.samePath(url)) {
          e.preventDefault();

          const ok = this.applyFiltersFromUrl(url);
          if (!ok) {
            // If no facets form found, fallback to navigation
            this.setDeferred('grid', { path: url.pathname });
            window.location.assign(url.toString());
            return;
          }

          // Scroll to grid after AJAX update
          this.scrollToGridAfterUpdate();
          return;
        }

        // If we are on product page (or elsewhere) -> navigate to URL, then scroll to grid on arrival
        this.setDeferred('grid', { path: url.pathname });
        // Allow default navigation (or force assign)
        return;
      }

      // Case B: link WITHOUT filter.* but has HASH -> treat as anchor (smooth scroll on collection)
      if (!hasFilter && hasHash && isTargetCollection) {
        // If already on collection page and same path -> smooth scroll now
        if (this.isCollectionPage() && this.samePath(url)) {
          e.preventDefault();
          this.scrollToHash(url.hash);
          return;
        }

        // From product -> collection#hash: navigate, then smooth scroll on arrival
        this.setDeferred('hash', { path: url.pathname, hash: url.hash });
        return;
      }

      // Case C: if already on collection page and link points to same path WITHOUT filter but maybe hash empty
      // Let default behavior occur (normal navigation).
      return;
    }
  }

  customElements.define('qfb-nav', QfbNav);
})();
